import moment from 'moment';

moment.locale('zh-cn');
export default (Vue) => {
  // 金额格式处理
  Vue.filter('money', (val) => {
    const result = ((!val || isNaN(val)) ? 0 : val).toLocaleString('en-US');
    return `￥${result}`;
  });
  // 距离现在
  Vue.filter('fromNow', (val) => {
    const date = moment(val).fromNow();
    return date;
  });
  // 时间格式化   YYYY-MM-DD HH:mm
  Vue.filter('timeFormat', (val, format) => {
    const d = new Date(val);
    const f = format || 'YYYY-MM-DD HH:mm';
    const date = moment(d).utc(true).format(f);
    return date;
  });
  // 文件大小过滤器
  Vue.filter('size', (val) => {
    if (!val) {
      return '0KB';
    }
    const size = val / 1000;
    if (size < 1024) {
      return `${size.toFixed(2)}KB`;
    }
    return `${(size / 1024).toFixed(2)}MB`;
  });
  // 时间格式化   MM-DD HH:mm
  Vue.filter('caseTimeOne', (val, format) => {
    const d = new Date(val);
    const f = format || 'MM-DD HH:mm';
    const date = moment(d).utc(true).format(f);
    return date;
  });
  // 时间格式化   MM-DD
  Vue.filter('caseTimeTwo', (val, format) => {
    const d = new Date(val);
    const f = format || 'MM-DD';
    const date = moment(d).utc(true).format(f);
    return date;
  });
};



// WEBPACK FOOTER //
// ./src/utils/filters.js